import axios from 'axios';
import { lhvConstants as sc } from '@/constants';
import {types} from "sass";
import { Commit } from "vuex";

// Commit and State
export interface CommitFunction {
    commit: Commit;
}

export interface CommitStateFunction<T> extends CommitFunction {
    state: T;
}

const initialUser = {
    username: null,
    ssn: null,
    phone: '+372',
    pin: null,
    errors: {},
};

// initialState
interface initialState {
    loading: boolean;
    step: string | null;
    user: any;
    authMethod: string | null;
    ibans: null | any;
    code: string | null;
    text: string | null;
    subStep: string | null;
    authMethods: any;
    payment: object;
    accounts: any;
    selectedAccount: string | null;
    paymentType: string;
    roles: any;
    selectedRole: string | null;
}

let initialState = {
    loading: false,
    step: null,
    user: {...initialUser},
    authMethod: null,
    code: null,
    text: null,
    subStep: null,
    payment: {},
    accounts: [],
    selectedAccount: null,
    paymentType: 'redirect',
    roles: [],
    selectedRole: null,
    authMethods: [
        // {
        //     name: 'Bio',
        //     value: 'BIO',
        // },
        {
            name: 'Mobile ID',
            value: 'MID',
        },
        {
            name: 'Smart ID',
            value: 'SID',
        },
        {
            name: 'PIN',
            value: 'PIN',
        },
        {
            name: 'ID Card',
            value: 'ID_CARD',
        },
    ],
};

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        // @ts-ignore
        async startLhvAuthorization({commit, state, rootState}: CommitStateFunction<initialState>, {swift} : {swift: string}) {
            await commit('setLoading', true);
            let isSuccessful = false;
            try {
                const payload = {
                    bic: swift,
                    method: state.authMethod,
                    username: state.user.username,
                    // @ts-ignore
                    ssn: ['SID', 'BIO'].includes(state.authMethod) ? state.user.ssn : null,
                    mobile_no: state.authMethod === 'MID' ? state.user.phone : null,
                    pin: state.authMethod === 'PIN' ? state.user.pin : null,
                    // @ts-ignore
                    payment_key: window.TarkPay.payment_id,
                    // @ts-ignore
                    client_id: window.TarkPay.client_id,
                };
                if (rootState.jwt) {
                    axios.defaults.headers["X-Jwt"] = rootState.jwt;
                }

                let response = await axios.post(`${process.env.VUE_APP_AS_API_URL}/api/v1/psd2/embed/${state.paymentType}/lhv/authorize/`, payload, {
                    params: {
                        // @ts-ignore
                        payment_key: window.TarkPay.payment_id,
                        // @ts-ignore
                        client_id: window.TarkPay.client_id,
                        payment_type: state.paymentType
                    },

                })

                if (response.headers["x-jwt"]) {
                    commit("setJwt", response.headers["x-jwt"], {root: true});
                }

                if (response.status === 200 && response.data.code) {
                    const data = response.data;
                    await commit('setCode', data.code);
                    await commit('setText', sc.TEXTS.VERIFY_CODE);
                    await commit('setStep', sc.SHOW_TEXT);
                    await commit('setSubStep', sc.AUTHORIZATION);
                    isSuccessful = true;
                } else {
                    let hasKnownError = false;

                    if (response.data.error) {
                        const returnedError = response.data.error;
                        if (['USER_ID_NOT_VALID', 'PSU_CREDENTIALS_INVALID', 'FORMAT_ERROR'].includes(returnedError)) {
                            hasKnownError = true;
                            await commit('setUserError', {prop: 'username', value: true});
                        } else if (['USER_NOT_VALID'].includes(returnedError)) {
                            hasKnownError = true;
                            await commit('setUserError', {prop: 'ssn', value: true});
                        } else if (['INTERNAL_SERVER_ERROR'].includes(returnedError) && state.authMethod === 'PIN') {
                            hasKnownError = true;
                            await commit('setUserError', {prop: 'pin', value: true});
                        }
                    }
                    if (!hasKnownError) {
                        await commit('setStep', sc.FAILED);
                    }
                }
            }
            catch (e) {
                console.log(e);
                await commit('setStep', sc.FAILED);
            }

            await commit('setLoading', false);
            return isSuccessful;
        },

        //@ts-ignore
        async pingLhvAuthorization({commit, state, rootState}: CommitStateFunction<initialState>,  {swift}: {swift: string}) {
            let isSuccessful = false;
            let hasRoles = false;

            try {

                if (rootState.jwt) {
                    axios.defaults.headers["X-Jwt"] = rootState.jwt;
                }

                let response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/api/v1/psd2/embed/${state.paymentType}/lhv/authorize/`, {
                    params: {
                        method: state.authMethod,
                        // @ts-ignore
                        payment_key: window.TarkPay.payment_id,
                        // @ts-ignore
                        client_id: window.TarkPay.client_id,
                        payment_type: state.paymentType
                    },

                })

                if (response.headers["x-jwt"]) {
                    commit("setJwt", response.headers["x-jwt"], {root: true});
                }
                if (!response || response.status !== 200) {
                    await commit('setStep', sc.FAILED);
                } else if (response.data && response.data.success === 1 && response.data.status === 'finalised') {
                    isSuccessful = true;
                    await commit('setCode', null);

                    if (response.data.roles) {
                        hasRoles = true;
                        await commit('setText', sc.TEXTS.SELECT_ROLE);
                        await commit('setStep', sc.SHOW_ROLES);
                        await commit('setSubStep', sc.SELECT_ROLE);
                        await commit('setRoles', response.data.roles);
                    } else {
                        await commit('setSubStep', sc.GET_ACCOUNTS);
                    }
                } else {
                    if (!response.data || !response.data.success) {
                        await commit('setStep', sc.FAILED);
                    }
                }
            }
            catch (e) {
                console.log(e);
                await commit('setStep', sc.FAILED);
            }

            await commit('setLoading', false);
            return {response: isSuccessful, hasRoles: hasRoles};
        },

        //@ts-ignore
        async handleRoleSelect({commit, state, rootState}: CommitStateFunction<initialState>,  {swift}: {swift: string}) {
            let isSuccessful = false;
            await commit('setLoading', true);

            try {

                if (rootState.jwt) {
                    axios.defaults.headers["X-Jwt"] = rootState.jwt;
                }

                const payload = {
                    selected_role: state.selectedRole,
                    // @ts-ignore
                    payment_key: window.TarkPay.payment_id,
                    // @ts-ignore
                    client_id: window.TarkPay.client_id,
                }

                let response = await axios.put(`${process.env.VUE_APP_AS_API_URL}/api/v1/psd2/embed/${state.paymentType}/lhv/authorize/`, payload,{
                    params: {
                        // @ts-ignore
                        payment_key: window.TarkPay.payment_id,
                        // @ts-ignore
                        client_id: window.TarkPay.client_id,
                        payment_type: state.paymentType
                    },

                })

                if (response.headers["x-jwt"]) {
                    commit("setJwt", response.headers["x-jwt"], {root: true});
                }
                if (!response || response.status !== 200) {
                    await commit('setStep', sc.FAILED);
                } else if (response.data && response.data.success === 1) {
                    isSuccessful = true;
                    await commit('setStep', sc.SHOW_TEXT);
                    await commit('setSubStep', sc.GET_ACCOUNTS);
                } else {
                    if (!response.data || !response.data.success) {
                        await commit('setStep', sc.FAILED);
                    }
                }
            }
            catch (e) {
                console.log(e);
                await commit('setStep', sc.FAILED);
            }

            await commit('setLoading', false);
            return isSuccessful;
        },

        //@ts-ignore
        async fetchAccounts({commit, state, rootState}: CommitStateFunction<initialState>,  {swift}: {swift: string}) {
            let isSuccessful = false;
            try {

                if (rootState.jwt) {
                    axios.defaults.headers["X-Jwt"] = rootState.jwt;
                }

                let response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/api/v1/psd2/embed/${state.paymentType}/lhv/accounts/`, {
                    params: {
                        // @ts-ignore
                        payment_key: window.TarkPay.payment_id,
                        // @ts-ignore
                        client_id: window.TarkPay.client_id,
                        payment_type: state.paymentType
                    },

                })

                if (response.headers["x-jwt"]) {
                    commit("setJwt", response.headers["x-jwt"], {root: true});
                }
                if (!response || response.status !== 200) {
                    await commit('setStep', sc.FAILED);
                } else if (response.data && response.data.success === 1 && response.data.accounts) {
                    isSuccessful = true;
                    await commit('setText', sc.TEXTS.ACCEPT_PAYMENT);
                    await commit('setCode', null);
                    await commit('setSubStep', sc.ACCEPT_PAYMENT);
                    await commit('setAccounts', response.data.accounts);
                } else {
                    if (!response.data || !response.data.success) {
                        await commit('setStep', sc.FAILED);
                    }
                }
            }
            catch (e) {
                console.log(e);
                await commit('setStep', sc.FAILED);
            }

            await commit('setLoading', false);
            return isSuccessful;
        },

        async startPaymentAuthorization({commit, state}: CommitStateFunction<initialState>, {swift} : {swift: string}) {
            await commit('setLoading', true);
            let isSuccessful = false;
            let isCompleted = false;

            try {
                const payload = {
                    bic: swift,
                    selected_iban: state.selectedAccount,
                    // @ts-ignore
                    payment_key: window.TarkPay.payment_id,
                    // @ts-ignore
                    client_id: window.TarkPay.client_id,
                    method: state.authMethod,
                    username: state.user.username,
                    // @ts-ignore
                    ssn: ['SID', 'BIO'].includes(state.authMethod) ? state.user.ssn : null,
                    mobile_no: state.authMethod === 'MID' ? state.user.phone : null,
                    pin: state.authMethod === 'PIN' ? state.user.pin : null,
                };

                let response = await axios.post(`${process.env.VUE_APP_AS_API_URL}/api/v1/psd2/embed/${state.paymentType}/lhv/payments/`, payload, {
                    params:
                        {
                            selected_iban: state.selectedAccount,
                            // @ts-ignore
                            payment_key: window.TarkPay.payment_id,
                            // @ts-ignore
                            client_id: window.TarkPay.client_id,
                            payment_type: state.paymentType
                        },
                });
                if (response.status === 200 && response.data && response.data.success === 1) {
                    const data = response.data;

                    if (data.status && data.status == 'finalised') {
                        isCompleted = true;
                        await commit('setCode', null);
                        await commit('setSubStep', null);
                        await commit('setText', null);
                        await commit('setStep', sc.SUCCESSFUL);
                    } else {
                        await commit('setCode', data.code);
                        await commit('setText', sc.TEXTS.VERIFY_CODE);
                        await commit('setStep', sc.SHOW_TEXT);
                        await commit('setSubStep', sc.CONFIRM_PAYMENT);
                    }
                    isSuccessful = true;
                } else {
                    await commit('setStep', sc.FAILED);
                }
            } catch (e) {
                console.error(e)
                if (e.message !== 'Network Error' && e.message !== 'The network connection was lost.') {
                    await commit('setStep', sc.FAILED);
                }
            }
            await commit('setLoading', false);

            return {response: isSuccessful, isCompleted};
        },
        async pingPaymentAuthorization({commit, state}: CommitStateFunction<initialState>, {swift} : {swift: string}) {
            let isSuccessful = false;
            try {
                let response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/api/v1/psd2/embed/${state.paymentType}/lhv/payments/`, {
                    params:
                        {
                            // @ts-ignore
                            payment_key: window.TarkPay.payment_id,
                            // @ts-ignore
                            client_id: window.TarkPay.client_id,
                            payment_type: state.paymentType
                        },
                });
                if (!response || response.status !== 200) {
                    await commit('setStep', sc.FAILED);
                } else if (response.data && response.data.success === 1 && response.data.status === 'finalised') {
                    isSuccessful = true;
                    await commit('setCode', null);
                    await commit('setSubStep', null);
                    await commit('setText', null);
                    await commit('setStep', sc.SUCCESSFUL);
                } else {
                    if (!response.data || !response.data.success) {
                        await commit('setStep', sc.FAILED);
                    }
                }
            } catch (e) {
                console.log(e);
                if (e.message !== 'Network Error' && e.message !== 'The network connection was lost.') {
                    await commit('setStep', sc.FAILED);
                }
            }
            await commit('setLoading', false);

            if (isSuccessful) {
                await commit('setLoading', true);
            }
            return isSuccessful;
        },
    },
    mutations: {
        setPaymentType(state: initialState, paymentType: string) {
            state.paymentType = paymentType
        },
        addPaymentInfo(state: initialState, payment: any) {
            state.payment = payment
        },
        setLoading(state: initialState, bool: boolean) {
            state.loading = bool;
        },
        setUser(state: initialState, {prop, value}: any) {
            state.user[prop] = value;
        },
        setUserError(state: initialState, {prop, value}: any) {
            state.user.errors[prop] = value;
        },
        setStep(state: initialState, value: any) {
            state.step = value;
            if (value === sc.FAILED) {
                state.text = initialState.text;
                state.code = initialState.code;
                state.accounts = initialState.accounts;
                state.subStep = initialState.subStep;
            }
        },
        setAuthMethod(state: initialState, value: any) {
            state.authMethod = value;
        },
        setCode(state: initialState, value: any) {
            state.code = value;
        },
        setText(state: initialState, value: any) {
            state.text = value;
        },
        setSubStep(state: initialState, value: any) {
            state.subStep = value;
        },
        resetStates(state: initialState) {
            state.step = initialState.step;
            state.code = initialState.code;
            state.subStep = initialState.subStep;
            state.accounts = initialState.accounts;
            state.selectedAccount = initialState.selectedAccount;
            state.authMethod = initialState.authMethod;
        },
        setAccounts(state: initialState, value: any) {
            state.accounts = value;
            state.selectedAccount = state.accounts.length > 0 ? state.accounts[0].iban : null;
        },
        setSelectedAccount(state: initialState, value: string) {
            state.selectedAccount = value;
        },
        setRoles(state: initialState, value: any) {
            state.roles = value;
            state.selectedRole = state.roles.length > 0 ? state.roles[0].id : null;
        },
        setSelectedRole(state: initialState, value: string) {
            state.selectedRole = value;
        },

    },
    getters: {},
};
